var _g, _path, _path2, _path3, _path4, _line, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnfurnished(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_9389_79076)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4397 20.1641C14.0337 20.1641 14.6035 20.4001 15.0236 20.8201C15.4436 21.2402 15.6796 21.8099 15.6796 22.404V24.644H26.8794V22.404C26.8794 21.8099 27.1154 21.2402 27.5355 20.8201C27.9555 20.4001 28.5253 20.1641 29.1194 20.1641C29.7134 20.1641 30.2832 20.4001 30.7032 20.8201C31.1233 21.2402 31.3593 21.8099 31.3593 22.404V26.8839C31.3593 27.478 31.1233 28.0477 30.7032 28.4678C30.2832 28.8879 29.7134 29.1239 29.1194 29.1239H13.4397C12.8456 29.1239 12.2758 28.8879 11.8558 28.4678C11.4357 28.0477 11.1997 27.478 11.1997 26.8839V22.404C11.1997 21.8099 11.4357 21.2402 11.8558 20.8201C12.2758 20.4001 12.8456 20.1641 13.4397 20.1641V20.1641Z",
    stroke: "#5F6787",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4396 20.161V14.5611C13.4396 13.67 13.7936 12.8154 14.4237 12.1853C15.0538 11.5552 15.9084 11.2012 16.7995 11.2012H25.7593C26.6504 11.2012 27.5051 11.5552 28.1352 12.1853C28.7653 12.8154 29.1193 13.67 29.1193 14.5611V20.161",
    stroke: "#5F6787",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5596 29.123V31.363",
    stroke: "#5F6787",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9993 29.123V31.363",
    stroke: "#5F6787",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9389_79076",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 33,
    height: 33
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 36.7537,
    y1: 5.95316,
    x2: 5.9537,
    y2: 36.7532,
    stroke: "#5F6787"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9389_79076)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_9389_79076)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -0.00195312,
    width: 42,
    height: 42,
    rx: 21,
    fill: "#5F6787"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_9389_79076",
    x: -17.662,
    y: -17.662,
    width: 77.324,
    height: 77.324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_9389_79076"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_9389_79076",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_9389_79076",
    x: -17.662,
    y: -17.664,
    width: 77.324,
    height: 77.324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_9389_79076"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_9389_79076",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfurnished);
export default __webpack_public_path__ + "static/media/unfurnished.78add724509290b5311c70f45f601f33.svg";
export { ForwardRef as ReactComponent };